import React, { PureComponent } from 'react'
import { withRouter } from 'react-router-dom'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { Spinner, SectionTab } from '../../../components'
import { THEMES } from '../../../utils'

import {
  createToast,
  getContact,
  getContactStrategy,
  updateContact,
  openModal,
  closeModal,
  statusType
} from '../../../actions'

import ContactDetailBanner from './banner/banner.component'
import ContactDetailSummary from './summary/summary.component'
import ContactDetailNotes from './tab/note/note.component'
import ContactManagedFunds from './tab/fund/fund.component'

const TABS = {
  NOTES: 'notes',
  FUNDS: 'funds'
}

/**
 * Contact detail page component
 */
class ContactDetailPage extends PureComponent {

  /**
   * Constructor
   * @param props
   */
  constructor (props) {
    super(props)
    this.state = {
      activeTab: TABS.NOTES
    }
  }

  /**
   * Component did mount
   */
  componentDidMount () {
    this.getContact()
  }

  /**
   * Get Contact by id
   */
  getContact () {
    const { getContact, getStrategy, match } = this.props
    const id = match && match.params && match.params.id

    if (id) {
      getContact(id)
      getStrategy(id)
    }
  }

  /**
   * Opens contact modal
   */
  onContactEdit () {
    const { contact, strategy, openModal } = this.props

    openModal({
      type: 'CONTACT_FORM',
      props: {
        contact,
        strategy,
        onSaveSuccess: this.getContact.bind(this)
      }
    })
  }

  /**
   * On Tab Change
   * @param event
   * @param value
   */
  onTabChange = (event, value) => {
    this.setState({
      activeTab: value || 'notes'
    })
  }

  /**
   * Render Contact List
   * @returns {*}
   */
  render () {
    const { loading, initialLoading, contact, strategy } = this.props
    const { activeTab } = this.state

    const id = contact._id
    const revisions = (contact.revisions || [])
      .sort((a, b) => new Date(b.update_date) - new Date(a.update_date))

    return (
      <>
        {loading && <Spinner theme={THEMES.WHITES} mask />}
        <ContactDetailBanner
          contact={{
            initialLoading,
            salutation: contact.salutation,
            fullName: contact.full_name,
            status: contact.status
          }}
          onContactEdit={this.onContactEdit.bind(this)} />

        <ContactDetailSummary
          contact={{
            id,
            source: contact.source,
            status: contact.status,
            salutation: contact.salutation,
            firstName: contact.first_name,
            lastName: contact.last_name,
            nickName: contact.nickname,
            jobs: contact.jobs,
            directPhone: contact.direct_phone,
            phoneExtension: contact.phone_extension,
            mobile: contact.mobile,
            email: contact.email,
            bio: contact.bio
          }}
          strategy={strategy} />

        <SectionTab
          theme={THEMES.RAIN}
          onChange={this.onTabChange}
          activeTab={activeTab}
          tabs={[
            {
              label: 'Notes',
              value: TABS.NOTES
            },
            {
              label: 'Managed Funds',
              value: TABS.FUNDS
            }
          ]} />

        {activeTab === TABS.NOTES && <ContactDetailNotes
          data={revisions}
        />}

        {activeTab === TABS.FUNDS && <ContactManagedFunds
          data={contact.managed_funds}
        />}
      </>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    loading: state.contact.contact.status === statusType.IN_PROGRESS,
    initialLoading: state.contact.contact.initialLoading,
    contact: state.contact.contact.data,
    strategy: state.contact.strategy.data
  }
}

const mapDispatchToProps = (dispatch) => ({
  getContact: bindActionCreators(getContact, dispatch),
  getStrategy: bindActionCreators(getContactStrategy, dispatch),
  updateContact: bindActionCreators(updateContact, dispatch),
  createToast: bindActionCreators(createToast, dispatch),
  openModal: bindActionCreators(openModal, dispatch),
  closeModal: bindActionCreators(closeModal, dispatch)
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ContactDetailPage))
